import { NgModule } from '@angular/core';
import { ElmBlockButtonComponent } from './elm-block-button.component';
import { ELM_BLOCK_BUTTON_DIRECTIVES } from './elm-block-button.directives';

@NgModule({
  exports: [ElmBlockButtonComponent, ELM_BLOCK_BUTTON_DIRECTIVES],
  declarations: [ElmBlockButtonComponent, ELM_BLOCK_BUTTON_DIRECTIVES]
})
export class ElmBlockButtonModule {}
